module.exports = __webpack_public_path__ + "static/media/areamap5.c41f1dcf.svg";